import { colors } from 'ui/theme';

export const mediumColors = [
  colors.salmon50,
  colors.mustard50,
  colors.cyan50,
  colors.purple90,
  colors.green50,
];
